import { Box, Text } from '@factorialco/deprecated-design-system'
import { Player } from '@lottiefiles/react-lottie-player'

import animation from './highFive.json'

interface Props {
  title: string
  description: string
}

const ModalHeader = ({ title, description }: Props) => {
  return (
    <Box flexDirection="column" alignItems="center" gap="s12">
      <Box paddingTop="s16">
        <Player autoplay loop src={animation} style={{ height: '168px' }}></Player>
      </Box>
      <Text.Header1 weight="bold">{title}</Text.Header1>
      <Box paddingX="s12" alignItems="center" textAlign="center">
        <Text.Normal color="grey700">{description}</Text.Normal>
      </Box>
    </Box>
  )
}

export default ModalHeader
